module.exports = __webpack_public_path__ + "static/2.feb6a8d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/portfolio/2.jpg
// module id = 439
// module chunks = 246384609461072